import {
    GuiaTarifaActionTypes,
    MARK_GUIA_TARIFA_DIRTY,
    RESET_GUIA_TARIFA,
    SET_GUIA_TARIFA_ERROR,
    SET_GUIA_TARIFA_LOADING,
    SET_GUIA_TARIFA_SUCCESS
} from "../types/guiaTarifaActionTypes";
import { IGuiaTarifa, initialGuiaTarifa } from "../../entities/guias/IGuiaTarifa";
import { RESET_GUIA_NUEVA } from "../types/guiaActionTypes";

type GuiaTarifaReducerAction =
    | GuiaTarifaActionTypes
    | { type: typeof RESET_GUIA_NUEVA };

export function guiaTarifaReducer(
    state: IGuiaTarifa = initialGuiaTarifa,
    action: GuiaTarifaReducerAction
): IGuiaTarifa {
    switch (action.type) {
        case SET_GUIA_TARIFA_LOADING:
            return {
                ...state,
                status: 'loading',
                errorMessage: ''
            };
        case SET_GUIA_TARIFA_SUCCESS:
            return {
                ...action.payload,
                status: 'ok',
                errorMessage: '',
                dirty: false
            };
        case SET_GUIA_TARIFA_ERROR:
            return {
                ...state,
                status: 'error',
                errorMessage: action.errorMessage || 'Error al recalcular tarifa',
                dirty: true
            };
        case MARK_GUIA_TARIFA_DIRTY:
            return {
                ...state,
                dirty: true
            };
        case RESET_GUIA_TARIFA:
        case RESET_GUIA_NUEVA:
            return { ...initialGuiaTarifa };
        default:
            return state;
    }
}
